import { nanoid } from 'nanoid'

/**
 * @property {String} id - id of the table item
 * @property {Boolean} removed - whether the table item is removed or not (only relevant if removable prop active)
 */

export default class SimpleTableItem {
  constructor(removed) {
    this.id = nanoid()

    /**
     * Whether the table item is removed or not (only relevant if removable prop active)
     * @type {Boolean}
     */
    this.removed = !!removed
  }
}
